import { APEX_API_URL } from '@/constants';
import { INextAuthSessionModel } from '@/interfaces/authentication';
import { IProfile, IProfileAddressModel, IProfileAddressPostModel, IProfileModel, IRewardPoint, IRewardPointTransaction, RewardBanner } from '@/interfaces/profile';

import { getAxiosInstance } from '@/utils/axios-instance';

export const updateProfile = async (item: IProfile): Promise<IProfile> => {
  let body = item;
  const response = await getAxiosInstance().put(`${APEX_API_URL}/api/profile`, body);
  return response.data;
};
export const getProfile = async (session?: INextAuthSessionModel | null): Promise<IProfileModel> => {
  // NOTE: in some cases, the accessToken(string) is being passed instead of session (INextAuthSessionModel)
  let accessToken: string;

  if (typeof session === 'string') {
    accessToken = session;
  } else if (session?.accessToken && typeof session.accessToken === 'string') {
    accessToken = session.accessToken;
  } else {
    throw new Error('Invalid session or access token provided');
  }

  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/profile`, {
    headers: {
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data;
};
export const getProfileAddressList = async (session?: INextAuthSessionModel | null): Promise<IProfileAddressModel[]> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/profile/address/list`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
  });
  return response.data;
};

export const getRewardPageBanner = async (): Promise<RewardBanner> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/RewardBanner/reward-banner`);
  return response.data;
};
export const updateProfileAddress = async (item: IProfileAddressPostModel): Promise<IProfileAddressPostModel> => {
  let body = item;
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/profile/address`, body);
  return response.data;
};
export const deleteProfileAddress = async (addressId: string, customerId: string): Promise<any> => {
  let body = {
    customerId,
    addressId,
  };
  const response = await getAxiosInstance().delete(`${APEX_API_URL}/api/profile/address`, { data: body });
  return response.data;
};
export const getRewardPoint = async (session?: INextAuthSessionModel | null): Promise<IRewardPoint> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/profile/reward-points`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
  });
  return response.data;
};
export const getRewardPointsTransaction = async (
  pageSize: number,
  pageNumber: number,
  session?: INextAuthSessionModel | null,
  showPurchaseOnly?: boolean,
): Promise<IRewardPointTransaction> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/profile/reward-points/transactions`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
    params: {
      pageSize,
      pageNumber,
      showPurchaseOnly,
    },
  });
  return response.data;
};

export const deleteProfile = async (accessToken?: string | null): Promise<any> => {
  const response = await getAxiosInstance().delete(`${APEX_API_URL}/api/profile`, {
    headers: {
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data;
};

export const postFeedback = async (item: FormData): Promise<any> => {
  let body = item;
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/ticket`, body);
  return response.data;
};
